import httpService from "./httpService";

// Helper to append to FormData only if value is not null/undefined
const appendFormDataValue = (formData, key, value) => {
  if (value !== null && value !== undefined) {
    formData.append(key, value);
  }
};

// Utility function to construct FormData for ACH requests
const buildAchFormData = (ach, attachments) => {
  const formData = new FormData();

  appendFormDataValue(formData, "ach.bankName", ach.bankName);
  appendFormDataValue(formData, "ach.routingNumber", ach.routingNumber);
  appendFormDataValue(formData, "ach.accountNumber", ach.accountNumber);
  appendFormDataValue(formData, "ach.accountTypeId", ach.accountTypeId);
  appendFormDataValue(formData, "ach.country", ach.country);
  appendFormDataValue(formData, "ach.id", ach.id);
  appendFormDataValue(formData, "ach.isActive", ach.isActive);

  if (ach.partiesByOrgUnitId && ach.partiesByOrgUnitId.length > 0) {
    ach.partiesByOrgUnitId.forEach((pair, index) => {
      appendFormDataValue(formData, `ach.partiesByOrgUnitId[${index}].key`, pair.key);

      if (pair.value && pair.value.length > 0) {
        pair.value.forEach((party, partyIndex) => {
          appendFormDataValue(formData, `ach.partiesByOrgUnitId[${index}].value[${partyIndex}].id`, party.id);
          appendFormDataValue(formData, `ach.partiesByOrgUnitId[${index}].value[${partyIndex}].name`, party.name);
          appendFormDataValue(
            formData,
            `ach.partiesByOrgUnitId[${index}].value[${partyIndex}].connectedCompanyId`,
            party.connectedCompanyId
          );
        });
      }
    });
  }

  if (attachments && attachments.length > 0) {
    attachments.forEach(file => {
      formData.append("attachments", file);
    });
  }

  return formData;
};

export default {
  create: async (ach, attachments = []) => {
    const formData = buildAchFormData(ach, attachments);
    return httpService.post("/ach", formData);
  },
  update: async (ach, attachments = []) => {
    const formData = buildAchFormData(ach, attachments);
    return httpService.put(`/ach/${ach.id}`, formData);
  },
  getAll: async () => httpService.get("/ach"),
  get: async id => httpService.get(`/ach/${id}`),
};
